/**
 * Test IDs for QA automation.
 */
export const testIds = {
  enumSelectClear: "enum-select-clear",
  enumSelectOption: "enum-select-option",
  enumSelectNone: "enum-select-none",
} as const;
